import api from './api'
import { BASE } from './config'

class TokenService {
  getLocalRefreshToken() {
    const user = JSON.parse(sessionStorage.getItem('user'))
    return user?.refresh
  }

  getLocalAccessToken() {
    const user = JSON.parse(sessionStorage.getItem('user'))
    return user?.access
  }

  updateLocalAccessToken(token) {
    let user = JSON.parse(sessionStorage.getItem('user'))
    user.access = token
    sessionStorage.setItem('user', JSON.stringify(user))
  }

  getUser() {
    return JSON.parse(sessionStorage.getItem('user'))
  }

  setUser(user) {
    sessionStorage.setItem('user', JSON.stringify(user))
  }

  removeUser() {
    sessionStorage.removeItem('user')
  }

  validateOneTimeToken(token) {
    return api.post(`${BASE}/one_time_tokens/validate/`, {
      token,
    })
  }
}

export default new TokenService()
